<template>
  <div>
    <p>designers users</p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
